function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
import * as client from '../internal/metrics/metrics.client';
var _config = /*#__PURE__*/ new WeakMap();
class Metrics {
    increment(...args) {
        client.increment(_class_private_field_get(this, _config), ...args);
    }
    gauge(...args) {
        client.gauge(_class_private_field_get(this, _config), ...args);
    }
    set(...args) {
        client.set(_class_private_field_get(this, _config), ...args);
    }
    constructor(config){
        _class_private_field_init(this, _config, {
            writable: true,
            value: void 0
        });
        _class_private_field_set(this, _config, config);
    }
}
// TODO: fix references to example files
export { Metrics as default };

//# sourceMappingURL=metrics.js.map